var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_vm.isAuthorized ? [_c("div", {
    staticClass: "submenus"
  }, [_vm.canManageLogisticCost ? _c("router-link", {
    staticClass: "router-link --no-hover-underlined",
    attrs: {
      to: {
        query: {
          tab: _vm.tabs.logisticCost
        }
      }
    }
  }, [_c("div", {
    staticClass: "submenus-item",
    class: [_vm.selectedTab === _vm.tabs.logisticCost ? "submenus-item--active" : ""]
  }, [_c("span", [_vm._v("Logistic costs")])])]) : _vm._e(), _vm.canManageImporters ? _c("router-link", {
    staticClass: "router-link --no-hover-underlined",
    attrs: {
      to: {
        query: {
          tab: _vm.tabs.importers
        }
      }
    }
  }, [_c("div", {
    staticClass: "submenus-item",
    class: [_vm.selectedTab === _vm.tabs.importers ? "submenus-item--active" : ""]
  }, [_c("span", [_vm._v("Importers")])])]) : _vm._e()], 1), _vm.selectedTab === _vm.tabs.logisticCost ? _c("div", [_c("LogisticCostList", {
    attrs: {
      loggedUserData: _vm.loggedUserData
    }
  })], 1) : _vm.selectedTab === _vm.tabs.importers ? _c("div", [_c("ImportersList", {
    attrs: {
      loggedUserData: _vm.loggedUserData
    }
  })], 1) : _vm._e()] : _c("Error", {
    attrs: {
      error: {}
    }
  })], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };